import water_use from "../../images/homepage/Water_Usage.png";
import soil_moisture from "../../images/homepage/Soil_Moisture_Map.png";
import "../../css/common.module.css";

export default function WaterMoisture() {
  return (
    <div className="container mt-6">
      <div className="row col-md-12 block-row">
        <div class="col-xs-12 col-sm-6 justify-content-start pt-2">
          <h5 class="card-header fw-semibold block-title" >
           Water Usage
          </h5>
          <p className="fs-5"> </p>
	      <span class="float-start"> <img className="img-fluid" src={water_use}
	       style={{
	            paddingLeft: "0px",
	            paddingRight: "0px",
	            width: "90%",
	            height: "350px",
	          }}
	      ></img></span>
	    </div>
	    <div class="col-xs-12 col-sm-6 justify-content-start pt-2">
	      <h5 class="card-header fw-semibold block-title">
           Soil Moisture Map
          </h5>
          <p className="fs-5"> </p>
	      <span class="float-start"> <img className="img-fluid" src={soil_moisture}
	       style={{
	            paddingLeft: "0px",
	            paddingRight: "0px",
	            width: "90%",
	            height: "350px",
	          }}
	          ></img></span>
	    </div>   
      </div>
    </div>
  );
}
